var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFileCircle2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666992,
    width: 34,
    height: 34,
    rx: 17,
    fill: "#D6E1FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.667 7C11.1366 7 10.6279 7.21071 10.2528 7.58579C9.87771 7.96086 9.66699 8.46957 9.66699 9V25C9.66699 25.5304 9.87771 26.0391 10.2528 26.4142C10.6279 26.7893 11.1366 27 11.667 27H23.667C24.1974 27 24.7061 26.7893 25.0812 26.4142C25.4563 26.0391 25.667 25.5304 25.667 25V13L19.667 7H11.667ZM11.667 9H18.667V14H23.667V25H11.667V9ZM13.667 17V19H21.667V17H13.667ZM13.667 21V23H18.667V21H13.667Z",
    fill: "#194CAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFileCircle2);
export default __webpack_public_path__ + "static/media/icon-file-circle-2.b1cf8ddde1ac7654b15231136e009ac4.svg";
export { ForwardRef as ReactComponent };